import { brandStorage as localStorage } from '@/utils/brandSession';
import React, { useEffect, useState } from 'react';
import axios from '../../utils/authenticatedAxios';
import { Star, Save } from 'lucide-react';
import { toast } from 'sonner';
import { API } from '../../utils/config';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';

const auth = () => ({ Authorization: `Bearer ${localStorage.getItem('hw_token')}` });
const URL_SETTINGS = `${API}/api/home-smart/communications/settings`;

export default function HomeSmartReviewLinkCard() {
  const [reviewUrl, setReviewUrl] = useState(''), [saved, setSaved] = useState(''), [busy, setBusy] = useState(false);
  useEffect(() => {
    axios.get(URL_SETTINGS, { headers: auth() }).then(({ data }) => { setReviewUrl(data.review_url || ''); setSaved(data.review_url || ''); })
      .catch(() => toast.error('Impossibile caricare il link delle recensioni'));
  }, []);
  const valid = !reviewUrl.trim() || /^https?:\/\/\S+$/.test(reviewUrl.trim());
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await axios.put(URL_SETTINGS, { review_url: reviewUrl.trim() }, { headers: auth() });
      setSaved(data.review_url); setReviewUrl(data.review_url);
      toast.success(data.review_url ? 'Link delle recensioni salvato' : 'Link delle recensioni rimosso');
    } catch (error) {
      toast.error(typeof error.response?.data?.detail === 'string' ? error.response.data.detail : 'Inserisci un link valido che inizia con https://');
    } finally { setBusy(false); }
  };
  return <Card data-testid="review-link-card">
    <CardHeader><CardTitle className="flex items-center gap-2"><Star className="h-5 w-5 text-blue-700" />Link per le recensioni</CardTitle></CardHeader>
    <CardContent className="space-y-3">
      <p className="text-sm text-slate-600">Un unico link per tutta l’azienda (ad esempio la tua pagina Google, Booking o Airbnb). Nelle email con <span className="font-mono">{'{pulsante_recensione}'}</span> diventa il pulsante «Lascia una recensione»; se il campo è vuoto il pulsante non compare.</p>
      <div className="space-y-2"><Label htmlFor="review-link-input">Indirizzo della pagina recensioni</Label>
        <Input id="review-link-input" type="url" inputMode="url" maxLength={500} placeholder="https://g.page/r/..." value={reviewUrl} onChange={(event) => setReviewUrl(event.target.value)} aria-invalid={!valid} data-testid="review-link-input" /></div>
      {!valid && <p role="alert" className="text-sm text-red-700" data-testid="review-link-error">Il link deve iniziare con https:// e non contenere spazi.</p>}
      <Button className="bg-blue-700 text-white hover:bg-blue-800" disabled={busy || !valid || reviewUrl.trim() === saved} onClick={save} data-testid="review-link-save-button"><Save className="mr-2 h-4 w-4" />{busy ? 'Salvataggio…' : 'Salva link'}</Button>
    </CardContent>
  </Card>;
}
